import './DatesRangeEditor.css';

import React, { useEffect, useState } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { generateClassName } from '../../../b2b-common/helpers';
import { DateTimePicker } from '@mui/x-date-pickers';

export const B2BDatePicker = ({
    objectHoldingDate,
    setObjectHoldingDate,
    objectDateField,
    label,
    value,
    className = null,
    disabledDateRanges = [],
    showTime = false,
    readOnly = false
}) => {
    const initialDateValue = showTime ? dayjs(value) : dayjs(value).startOf('day');
    const [dateValue, setDateValue] = useState(initialDateValue);

    useEffect(() => {
        if (!value) {
            const today = dayjs().startOf('day');
            handleDateChange(today);
        } else {
            const dateValue = showTime ? dayjs(value) : dayjs(value).startOf('day');
            if (showTime) {
                handleDateTimeChange(dateValue);
            } else {
                handleDateChange(dateValue);
            }
        }
    }, [value, showTime]);

    const handleDateChange = (date) => {
        setDateValue(date);
        setObjectHoldingDate({ ...objectHoldingDate, [objectDateField]: date.format('YYYY-MM-DD') });
    };

    const handleDateTimeChange = (date) => {
        setDateValue(date);
        setObjectHoldingDate({ ...objectHoldingDate, [objectDateField]: date.format('YYYY-MM-DDTHH:mm:ss') });
    };

    const isDateDisabled = (date) => {
        return disabledDateRanges.some(range =>
            date.isAfter(dayjs(range.start).startOf('day')) && date.isBefore(dayjs(range.end).endOf('day'))
        );
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
            {!showTime ?
                (<DatePicker
                    label={label}
                    value={dateValue}
                    onChange={handleDateChange}
                    shouldDisableDate={isDateDisabled}
                    className={generateClassName('date-picker', '-component', className)}
                    slotProps={{ textField: { variant: 'standard' } }}
                    readOnly={readOnly}
                />) :
                (<DateTimePicker
                    label={label}
                    value={dateValue}
                    onChange={handleDateTimeChange}
                    shouldDisableDate={isDateDisabled}
                    className={generateClassName('date-time-picker', '-component', className)}
                    slotProps={{ textField: { variant: 'standard' } }}
                    readOnly={readOnly}
                />)
            }
        </LocalizationProvider>
    );
};

const DatesRangeEditor = ({
    datesRangeHolder,
    setDatesRangeHolder,
    startDateLabel,
    endDateLabel,
    startDateField,
    endDateField,
    className = null,
    disabledDateRanges = [],
}) => {
    // console.log('DatesRangeEditor', datesRangeHolder);

    return (
        <div className={generateClassName('edit-dates-range', '', className)}>
            <B2BDatePicker
                objectHoldingDate={datesRangeHolder}
                setObjectHoldingDate={setDatesRangeHolder}
                objectDateField={startDateField}
                label={startDateLabel}
                value={datesRangeHolder[startDateField]}
                disabledDateRanges={disabledDateRanges}
                className={generateClassName('edit-dates-range', '-start-date-picker', className)}
            />
            <B2BDatePicker
                objectHoldingDate={datesRangeHolder}
                setObjectHoldingDate={setDatesRangeHolder}
                objectDateField={endDateField}
                label={endDateLabel}
                value={datesRangeHolder[endDateField]}
                disabledDateRanges={disabledDateRanges}
                className={generateClassName('edit-dates-range', '-end-date-picker', className)}
            />
        </div>
    );
};

export default DatesRangeEditor;